import * as React from "react";

const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "commonImages",
            label: t ? t("common.complete_line_photo") : "Zdjęcie kompletnej linii",
            column: 1,
            type: "file"
        },
    ]


});

export default fields;